import dsv from "./dsv.js";

var tsv = dsv("\t");

export var tsvParse = tsv.parse;
export var tsvParseRows = tsv.parseRows;
export var tsvFormat = tsv.format;
export var tsvFormatBody = tsv.formatBody;
export var tsvFormatRows = tsv.formatRows;
export var tsvFormatRow = tsv.formatRow;
export var tsvFormatValue = tsv.formatValue;



//////////////////
// WEBPACK FOOTER
// ./~/d3-dsv/src/tsv.js
// module id = 621
// module chunks = 0